import React from 'react';

const About = () => {
  return (
    <div className="section about-container bg-gray" id="about">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 d-none d-lg-block text-center">
            <img
              src="assets/img/illustration/2.png"
              alt="About Illustration"
              className="about-img"
            />
          </div>

          <div className="col-lg-6 col-md-12 text-wrapper">
            <h4 className="section-heading-left">About Us</h4>
            <h3 className="section-subtitle-left">Digital analysts with a technical edge</h3>
            <p>Deed Digital specializes in the strategic intersection of technology and marketing. We craft websites where data informs decisions, analytics guide development, and every feature serves a clear purpose in your digital strategy.</p>
            
            <div className="about-list-container">
              <ul className="about-list">
                <li>
                  <div className="title-container">
                    <h5 className="heading-left" style={{ color: '#3366cc' }}><strong>Insight-driven approach</strong></h5>
                  </div>
                  <p>Analytics-backed strategies that transform visitor behavior into business opportunities.</p>
                </li>
                <li>
                  <div className="title-container">
                    <h5 className="heading-left" style={{ color: '#3366cc' }}><strong>SEO and marketing focused</strong></h5>
                  </div>
                  <p>Technical foundations built for visibility, engagement, and competitive advantage.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
